import { useParams } from "react-router-dom";

import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { Selector } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useSelector } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { EditSelectorHost } from "./";

export const EditSelector: React.FC = () => {
  const { selectorId } = useParams<{ selectorId: string }>();

  const selectorQuery = useSelector(selectorId!);

  return (
    <QueryStateIndicator<Selector> {...selectorQuery}>
      {selector => <EditSelectorHost modeLabel="Edit" selector={selector} />}
    </QueryStateIndicator>
  );
};
